class EnvHelper {
    public static isDevelopmentQa = () => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'NURSERY';
        } else if (ENV_NAME === 'staging') {
            return 'NURSERY STAGING';
        } else if (ENV_NAME === 'qa') {
            return 'NURSERY QA';
        } else if (ENV_NAME === 'dev') {
            return 'NURSERY DEV';
        } else {
            return 'NURSERY ENV NOT FOUND';
        }
    };
}

export default EnvHelper;